import React, { Component } from "react";
import { GetControlPropertyFromStoreOrRefData } from "../../../General/commonFunctions";
import { ownStore } from "../../../AppOwnState/ownState";

class FactsImage extends Component {
  constructor(props) {
    super(props);
    let fileContentFromState = GetControlPropertyFromStoreOrRefData(
      props.src,
      props.refData
    );
    let disp = "inline";
    if (!fileContentFromState && fileContentFromState === "") disp = "none";
    this.state = {
      fileContent: fileContentFromState,
      showImage: disp,
      zoom: 1, // Initial zoom level
      lastDistance: null, // Last distance between two fingers
    };
  }

  ripOffControlSpecificAttributes() {
    const excluded = ["src", "staticimage", "refData"];
    return Object.keys(this.props)
      .filter((t) => !excluded.includes(t))
      .reduce((obj, key) => {
        obj[key] = this.props[key];
        return obj;
      }, {});
  }

  componentDidMount() {
    this.mounted = true;
    if (!this.props.staticimage) {
      this.unsubscribe = ownStore.subscribe(() => {
        if (this.mounted) {
          let newState = GetControlPropertyFromStoreOrRefData(
            this.props.src,
            this.props.refData
          );
          let disp = "inline";
          if (!newState && newState === "") disp = "none";

          if (this.state.fileContent !== newState) {
            this.setState({
              fileContent: newState,
              showImage: disp,
            });
          }
        }
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.unsubscribe) this.unsubscribe();
  }

  handlePinchStart = (e) => {
    if (e.touches.length === 2) {
      const distance = this.calculateDistance(e.touches[0], e.touches[1]);
      this.setState({ lastDistance: distance });
    }
  };

  handlePinchMove = (e) => {
    if (e.touches.length === 2) {
      const distance = this.calculateDistance(e.touches[0], e.touches[1]);
      const { lastDistance, zoom } = this.state;

      if (lastDistance) {
        const zoomChange = (distance - lastDistance) / 200; // Adjust sensitivity
        this.setState({
          zoom: Math.max(zoom + zoomChange, 0.1), // Ensure zoom doesn't go below 0.1
          lastDistance: distance,
        });
      }
    }
  };

  handlePinchEnd = () => {
    this.setState({ lastDistance: null });
  };

  calculateDistance = (touch1, touch2) => {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  render() {
    let newProps = this.ripOffControlSpecificAttributes();
    let zoomInOUt = newProps.zoomInOUt;
    const { zoom, showImage, fileContent } = this.state;
    // console.log(newProps.width,newProps.height,newProps.canvWidth,newProps.canvHeight)
    if (zoomInOUt) {
      return (
        <div
          style={{
            position: "relative",
            width: newProps.width,
            height: newProps.height,
            overflow: "auto",
            border: "1px solid #ccc",
          }}
          onTouchStart={this.handlePinchStart} // Detect start of pinch
          onTouchMove={this.handlePinchMove} // Detect pinch motion
          onTouchEnd={this.handlePinchEnd} // Detect end of pinch
        >
          <div
            style={{
              width: `${newProps.canvWidth * zoom}px`, // Dynamically resize based on zoom level
              height: `${newProps.canvHeight * zoom}px`, // Dynamically resize based on zoom level
              position: "relative",
            }}
          >
            <img
              className="factsImage"
              src={fileContent}
              alt="No Image Found"
              {...newProps}
              style={{
                display: showImage,
                width: "100%", // Ensure image stretches to container
                height: "100%", // Ensure image stretches to container
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <img
          className="factsImage"
          src={this.state.fileContent}
          alt="Stateful Graphic"
          {...newProps}
          style={{ display: this.state.showImage, ...newProps?.style }}
        />
      );
    }
  }
}

export default FactsImage;
